// ============================================================================
// ADD-ON REQUEST ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/lmms/v1/addon-requests';

export const addonRequestEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  submit: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/submit`, { id }),
  eligibilityCheck: () => buildEndpoint(`${BASE_PATH}/eligibility-check`),
  checkDuplicateLoanAccount: (loanAccountNumber: string, excludeId?: string) => {
    const params = new URLSearchParams({ loanAccountNumber });
    if (excludeId) params.append('excludeId', excludeId);
    return buildEndpoint(`${BASE_PATH}/check-duplicate-loan-account?${params.toString()}`);
  },
} as const;

export default addonRequestEndpoints;
